var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Layout',{staticClass:"app-layout"},[_c('Header',{style:({position: 'fixed', width: '100%'})},[_c('TopBar')],1),_c('Content',{staticClass:"app-content",style:({margin: '50px 0 0', background: '#fff', minHeight: '500px'})},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }